import { Accept as DropzoneAccept } from 'react-dropzone';

export const acceptToString = (accept?: DropzoneAccept): string | undefined => {
  if (!accept) return undefined;
  if (typeof accept === 'string') return accept;
  if (Array.isArray(accept)) return accept.join(',');
  const mimes = Object.keys(accept);
  const exts = Object.values(accept).flat();
  return [...mimes, ...exts].join(',');
};